"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketWebsiteInput_1 = require("./PutBucketWebsiteInput");
var PutBucketWebsiteOutput_1 = require("./PutBucketWebsiteOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketWebsite = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketWebsite",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?website"
    },
    input: {
        shape: PutBucketWebsiteInput_1.PutBucketWebsiteInput
    },
    output: {
        shape: PutBucketWebsiteOutput_1.PutBucketWebsiteOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketWebsite.js.map